// extracted by mini-css-extract-plugin
export default {"nav":"MyaVaS","menuToggle":"gIn6Wf","toggleOpen":"ZhsSZ_","buttonContainer":"P4my70"};